{
  "handicap_recommendations": {
    "title": "Handikapprekommendationer",
    "add_new": "Lägg till ny",
    "edit": "Redigera rekommendation",
    "all_types": "Alla speltyper",
    "percentages_help": "Ange procentsatser separerade med kommatecken, t.ex. 30,20,10",
    "table": {
      "play_type": "Spelform",
      "team_size": "Lagstorlek",
      "counting_scores": "Räknande resultat",
      "handicap_factor": "Handikapfaktor",
      "team_percentages": "Lagets handikapprocent",
      "description": "Beskrivning",
      "source": "Källa",
      "status": "Status",
      "men_max": "Herrar max",
      "women_max": "Damer max"
    },
    "no_recommendations": "Inga handikapprekommendationer."
  },
  "search_users": "Sök användare...",
  "no_users_found": "Inga användare hittades",
  "users_table": {
    "name": "Namn",
    "email": "E-post",
    "role": "Roll",
    "tenant": "Klubb",
    "created": "Skapad",
    "icons": {
      "course_conditions": "Användaren har rundor med sparade banförhållanden",
      "friends": "Användaren har vänner",
      "statistics": "Användaren har rundor med sparad statistik"
    },
    "user": "Användare"
  },
  "create_user": "Skapa användare",
  "create_user_page": {
    "title": "Skapa ny användare",
    "section_account": "Kontoinformation",
    "section_personal": "Personuppgifter",
    "section_golf": "Golfinformation",
    "email": "E-post",
    "password": "Lösenord",
    "first_name": "Förnamn",
    "last_name": "Efternamn",
    "gender": "Kön",
    "date_of_birth": "Födelsedatum",
    "handicap_index": "Handikapp",
    "role": "Roll",
    "tenant": "Kund",
    "no_tenant": "Ingen kund",
    "submit": "Skapa användare",
    "success": "Användaren skapades",
    "error": "Det gick inte att skapa användaren",
    "password_requirements": "Minst 8 tecken, stor och liten bokstav samt siffra",
    "email_taken": "E-postadressen används redan",
    "email_required": "E-post är obligatoriskt",
    "email_invalid": "Ogiltig e-postadress",
    "first_name_required": "Förnamn är obligatoriskt",
    "last_name_required": "Efternamn är obligatoriskt",
    "username": "Användarnamn"
  },
  "edit_user_page": {
    "save": "Spara",
    "delete": "Ta bort",
    "delete_confirm_title": "Ta bort användare",
    "delete_confirm_message": "Vill du verkligen ta bort användaren {{name}}?",
    "password_hint": "Lämna tomt om du inte vill byta lösenord",
    "success": "Användaren uppdaterades",
    "deleted": "Användaren togs bort",
    "not_found": "Användaren hittades inte",
    "refresh_handicap": "Uppdatera från eBirdie",
    "refresh_handicap_updated": "Handikapp uppdaterat: {{value}}",
    "refresh_handicap_unchanged": "Handikapp är redan aktuellt",
    "refresh_handicap_null": "Inget handikapp erhölls från eBirdie",
    "refresh_handicap_failed": "Hämtning av handikapp från eBirdie misslyckades",
    "refresh_handicap_not_linked": "Användaren har inget kopplat SuomiGolf-konto",
    "results_table": {
      "title": "Spelade rundor",
      "when": "Spelad",
      "where": "Bana",
      "tee": "Tee",
      "type": "Typ",
      "status": "Status",
      "ebirdie_status": "eBirdie",
      "resend": "Skicka igen",
      "resend_success": "Sändning startad på nytt",
      "resend_failed": "Omsändning misslyckades",
      "confirm_resend_title": "Skicka till eBirdie igen",
      "confirm_resend_body": "Vill du skicka rundan spelad {{date}} på banan {{course}} till eBirdie igen?",
      "no_results": "Inga spelade rundor",
      "type_competition": "Tävlingsrunda",
      "type_handicap": "Handikappgrundande runda",
      "type_round": "Träningsrunda",
      "status_completed": "Klar",
      "status_in_progress": "Pågående",
      "status_abandoned": "Avbruten",
      "status_disqualified": "Diskvalificerad",
      "ebirdie_status_completed": "Skickad",
      "ebirdie_status_queued": "I kö",
      "ebirdie_status_failed": "Fel",
      "ebirdie_status_permanent_failure": "Permanent fel"
    },
    "email_hint": "Bytet träder i kraft omedelbart utan bekräftelsemeddelande",
    "registration_method": "Registreringsmetod",
    "registration_time": "Registreringstid",
    "section_account": "Kontoinformation",
    "section_personal": "Personuppgifter",
    "section_golf": "Roll",
    "registered": "Registrerad",
    "time": "Tid",
    "ebirdie_linked": "eBirdie länkad",
    "hcp": "HCP",
    "customer": "Kund (klubb)",
    "tabs": {
      "basic": "Grunduppgifter",
      "rounds": "Spelade rundor"
    }
  },
  "users_page": {
    "refresh_all_handicaps": "Uppdatera handikapp",
    "refresh_all_summary": "Uppdaterade {{updated}}/{{scanned}} (oförändrade {{unchanged}}, tomma {{nullFromEbirdie}}, fel {{failed}})"
  }
}
